<template lang="pug">
div.fill-height
  v-card.round-xl.fill-height(outlined)
    .treatment-filters
      v-progress-linear(v-if="loading || isFetchingInvoice || isFetchingActiveMeds" :width="3" rounded color="primary" indeterminate)
      div.d-flex.align-center.px-4.py-2
        div.text-sm.font-medium.neutral700--text Items
          span.font-medium.custom-chip.neutral100--text(style="background-color: var(--v-neutral500)") {{ treatments.length }}
        v-spacer
        y-button(v-if="!isCancelled" label="Edit" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="onOpenTreatmentPlanDialog")
      v-divider
    template(v-if="loading")
      v-skeleton-loader.px-4(type="list-item-three-line@3")
    template(v-else-if="treatmentList.length === 0")
      div.d-flex.align-center.justify-center.fill-height(style="min-height: 200px;")
        div(align="center")
          v-icon(size="32" color="neutral500") $yzi-file-02
          div.text-sm.font-medium.neutral700--text.mt-2 No treatment and services selected yet
          div.text-sm.neutral500--text.mt-1 Start adding items to see them here
          y-button.mt-2(v-if="!isCancelled" label="Add treatment" color="neutral300" text-color="neutral700" prepend-icon="mdi-plus" icon-size="16" icon-color="neutral500" unset-min-width size="xs" button-class="px-2" @click="showTreatmentPlanDialog = true")
    template(v-else)
      div.pb-3
        div
          template(v-for="(treatment, idx) in treatmentList")
              v-divider(v-if="idx")
              treatment-item(:treatment="treatment" :item-index="idx" :show-print-label="false" :key="`tr-${idx}`" @updated="onUpdateTreatments")
  .dialogs
    treatment-plan-dialog(v-if="showTreatmentPlanDialog" :open.sync="showTreatmentPlanDialog" :edit-mode="true" :show-patient-info="false" :inventory-only="true" :allow-out-of-stock="allowOutOfStock" :from-reservation-preorder="true" @closed="onClosedTreatmentPlan" @updated="onUpdateTreatments")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TreatmentItem from '@/components/clinic/checkout/TreatmentItem.vue'
import TreatmentPlanDialog from '@/components/clinic/consultation/TreatmentPlanDialog.vue'

export default {
  components: { TreatmentItem, TreatmentPlanDialog },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isCancelled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'reservation'
    },
  },
  data () {
    return {
      showTreatmentPlanDialog: false,
      isFetchingInvoice: false,
      isFetchingActiveMeds: false,
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      leadPid: 'reservationPreorder/getLeadPid',
      patient: 'reservationPreorder/getPatient',
      treatments: 'reservationPreorder/getTreatments',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq',
    }),
    treatmentList () {
      return this.treatments
    },
    allowOutOfStock () {
      return this.type === 'preorder'
    },
  },
  methods: {
    onOpenTreatmentPlanDialog () {
      this.showTreatmentPlanDialog = true
    },
    onClosedTreatmentPlan () {
      this.showTreatmentPlanDialog = false
    },
    onUpdateTreatments () {
      this.fetchInvoice()
      this.fetchActiveMedication()
      this.showTreatmentPlanDialog = false
      this.$emit('updated')
    },
    fetchInvoice () {
      this.isFetchingInvoice = true
      this.$axios.get(`/invoices/${this.leadPid}`)
        .then(resp => {
          this.$store.commit('reservationPreorder/setInvoice', resp.data)
          this.$store.commit('treatment/setInvoice', resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingInvoice = false
        })
    },
    fetchActiveMedication () {
      this.isFetchingActiveMeds = true
      const params = {
        page_size: -1,
        patient: this.patient.id,
        expand: 'medication'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/active_medications`, { params })
        .then(resp => {
          let activeMedications = []
          if (resp.data && resp.data.results) {
            activeMedications = resp.data.results.map(m => { return { id: m.id, m_id: m.medication.id, name: m.medication.name } })
          }
          this.$store.commit('reservationPreorder/setActiveMedications', activeMedications)
          this.$store.commit('treatment/setActiveMedications', activeMedications)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingActiveMeds = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-chip {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  margin-left: 4px;
}
</style>
